<template>
  <Accordion title="Dados da Correção">
    <Grid cols-4 gap-5 class="mb-5">
      <InputNumber :modelValue="localValue.id" disabled label="Código" />
      <Select :items="type" :modelValue="localValue.type" label="Tipo" disabled />
      <InputZoom disabled label="Responsável" :modelValue="localValue.idUser" database="user" item-value="id" item-text="name" placeholder="Responsável" />
      <InputDateTime :modelValue="localValue.date" label="Data" disabled />
    </Grid>
    <div class="text-lg font-semibold mb-3">Itens Corrigidos</div>
    <TheTable dense :headers="itemsHeader" :items="correctionItems" :disablePagination="true">
      <template v-slot:name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:original="{ item }">
        <InputNumber :modelValue="item.original" dense :error="localErrors?.items?.[item.idItem]" disabled />
      </template>
      <template v-slot:newValue="{ item }">
        <InputNumber :modelValue="item.newValue" dense :error="localErrors?.items?.[item.idItem]" disabled />
      </template>
      <template v-slot:difference="{ item }">
        <InputNumber :modelValue="item.quantity" dense :error="localErrors?.items?.[item.idItem]" disabled> </InputNumber>
      </template>
    </TheTable>
    <TextArea class="mt-5" v-model="localValue.description" label="Descrição" placeholder="Descrição da Correção" :error="localErrors.description" />
  </Accordion>
</template>

<script setup>
import { computed, watch } from 'vue'
import InputNumber from '../../molecules/InputNumber.vue'
import TextArea from '../../molecules/TextArea.vue'

const type = [
  {
    label: 'Correção de Aplicação',
    value: 'applicationCorrection',
  },
  {
    label: 'Correção de Baixa',
    value: 'downwardCorrection',
  },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = computed(() => props.modelValue)
const localErrors = computed(() => props.error)

watch(
  () => localValue.value?.description,
  (newValue) => {
    if (localValue.value || newValue) {
      emits('update:modelValue', localValue.value)
    }
  },
)

const itemsHeader = [
  { title: 'Código', field: 'code', disableOrder: true, width: '120px' },
  { title: 'Item', field: 'name', disableOrder: true, width: '320px' },
  { title: 'Original', field: 'original', disableOrder: true, width: '130px' },
  { title: 'Novo Valor', field: 'newValue', disableOrder: true, width: '130px' },
  { title: 'Corrigido', field: 'difference', disableOrder: true, width: '130px' },
]

const correctionItems = computed(() => {
  if (!localValue.value.items || !localValue.value.originalMovement?.items) {
    return []
  }

  return localValue.value.items.map((item) => {
    const originalItem = localValue.value.originalMovement.items.find((orig) => orig.idItem === item.idItem)
    const original = originalItem?.quantity || 0
    const difference = item.quantity || 0
    return {
      ...item,
      original: original,
      newValue: original + difference,
      quantity: difference > 0 ? `+${difference}` : `${difference}`,
    }
  })
})
</script>
